/*! Cart purchase-terms gate */
(() => {
  if (window.__cartTermsInit) return;
  window.__cartTermsInit = true;

  const ATTRIBUTE = 'Sutikimas su pirkimo taisyklėmis';

  const boxes = () => [...document.querySelectorAll('.cart-terms__checkbox')];
  const accepted = () => boxes().some((b) => b.checked);

  const applyGate = () => {
    const ok = accepted();
    document.querySelectorAll('button[name="checkout"]').forEach((btn) => {
      if (btn.dataset.termsSkip === undefined && btn.disabled && !btn.dataset.termsLocked) {
        // disabled for another reason (e.g. empty cart) — leave it alone
        btn.dataset.termsSkip = 'true';
        return;
      }
      if (btn.dataset.termsSkip) return;
      btn.disabled = !ok;
      btn.dataset.termsLocked = ok ? '' : 'true';
      btn.classList.toggle('cart-terms-locked', !ok);
    });
    document.querySelectorAll('.additional-checkout-buttons').forEach((el) => {
      el.classList.toggle('cart-terms-locked', !ok);
      el.inert = !ok;
    });
  };

  const persist = (checked) => {
    const attributes = {};
    attributes[ATTRIBUTE] = checked ? 'Taip / Yes' : '';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes }),
    }).catch(() => {});
  };

  document.addEventListener('change', (evt) => {
    if (!evt.target.classList || !evt.target.classList.contains('cart-terms__checkbox')) return;
    const checked = evt.target.checked;
    boxes().forEach((b) => { b.checked = checked; });
    persist(checked);
    applyGate();
  });

  // Cart surfaces (drawer especially) re-render via AJAX, replacing gated
  // buttons with fresh enabled copies — reapply the gate on DOM changes.
  let gateQueued = false;
  const queueGate = () => {
    if (gateQueued) return;
    gateQueued = true;
    requestAnimationFrame(() => {
      gateQueued = false;
      applyGate();
    });
  };

  const init = () => {
    applyGate();
    new MutationObserver(queueGate).observe(document.body, { childList: true, subtree: true });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
